// extracted by mini-css-extract-plugin
export default {"ProductQtde_mobile_container":"ProductQtyMobile_ProductQtde_mobile_container__qox2X","OpenSelect_btn":"ProductQtyMobile_OpenSelect_btn__VVIr0"};